module.exports = __webpack_public_path__ + "img/hand_2_on.f7becf58.svg";